export const isEmpty = function (str: unknown) {
  return str === undefined || str === null || str === "" || str === false;
};

export const getDate = function (date: string): Date {
  const arr = date.split(/[-:\s]/).map(Number);
  const arg = arr.concat(new Array(6 - arr.length).fill(0));
  arg[1] = arg[1] && arg[1] > 0 ? arg[1] - 1 : 0;
  return new Date(arg[0], arg[1], arg[2], arg[3], arg[4], arg[5]);
};

export const isArray = function (arr: unknown) {
  return Object.prototype.toString.call(arr) === "[object Array]";
};

export const toast = (p: string) => {
  const toast = document.createElement("div");
  toast.setAttribute("class", "_toast");
  const num = document.querySelectorAll("._toast").length;
  toast.style.top = `${200 + num - 1 * 100 + 20}px`;
  toast.appendChild(document.createTextNode(p));
  document.body.appendChild(toast);
  if (toast) {
    setTimeout(() => {
      document.body.removeChild(toast);
    }, 3000);
  }
};

export const randomString = function (len: number) {
  len = len || 32;
  const chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
  const maxPos = chars.length;
  let pwd = "";
  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
};

/**
 * 根据常量值获取常量名称
 * @param list 常量列表数组
 * @param value 常量值
 * @param valKey 常量值key
 * @param nameKey 常量名称key
 * **/
export const getKeyTitle = function <T extends { [key: string]: unknown }>(
  list: Array<T>,
  value: T[keyof T],
  valKey: keyof T = "key",
  nameKey: keyof T = "title"
): T[keyof T] | undefined {
  let res: T | undefined;
  if (list) {
    res = list.find((item) => item[valKey] == value);
  }
  return res ? res[nameKey] : undefined;
};

/**
 * 在数字前面自动补0
 * @param {*} num 数字
 * @param {*} length 返回的字符长度
 * @returns {string}
 * e.g:
 * paddingZero(1, 2) => "01"
 * paddingZero(1, 3) => "001"
 */
export const paddingZero = function (
  num: number | string,
  length: number
): string {
  const str = num + "";
  return str.length >= length ? str : paddingZero("0" + str, length);
};

export const pick = function <T>(obj: T, keys: Array<keyof T>): Partial<T> {
  return keys.reduce((result, key) => {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      result[key] = obj[key];
    }
    return result;
  }, {} as Partial<T>);
};
export function omit<T extends object>(obj: T, uselessKeys: Array<keyof T>) {
  let key: keyof T;
  const res: Partial<T> = {};
  for (key in obj) {
    if (!uselessKeys.includes(key)) {
      res[key] = obj[key];
    }
  }
  return res;
}

export const downLoadBlobFile = function (content: Blob, fileName: string) {
  const blob = new Blob([content]);
  if ("download" in document.createElement("a")) {
    // 非IE下载
    const elink = document.createElement("a");
    elink.download = fileName;
    elink.style.display = "none";
    elink.href = URL.createObjectURL(blob);
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href); // 释放URL 对象
    document.body.removeChild(elink);
  }
};
